<template>
    <section class="administration-organisation">
        <div class="form">
            <div class="grid-x">
                <div class="flexbox-center" style="width: 40px;"></div>
                <div class="cell small-3 medium-3 large-3 flexbox align-items"></div>
                <div class="cell auto flexbox-center" style="max-width: 350px;">
                    <icon class="huge-svg fill-dark-gray" name="group" />
                </div>
            </div>
        </div>

        <hr />

        <div class="form">
            <div class="grid-x">
                <div class="flexbox-center">
                    <icon class="small-label-svg" name="envelope" />
                </div>
                <div class="cell small-3 flexbox align-items">
                    <label for="organisationEmail">E-mail</label>
                </div>
                <div class="auto cell">
                    <email-validation id="organisationEmail" :existingUser="tempFirm.email" v-model="tempFirm.email" @validateEmail="validEmailResult" />
                </div>
            </div>
        </div>

        <hr />

        <div class="form">
            <div class="grid-x">
                <div class="flexbox-center">
                    <icon class="small-label-svg" name="group" />
                </div>
                <div class="cell small-3 flexbox align-items">
                    <label for="organisationName">Navn</label>
                </div>
                <div class="auto cell">
                    <input type="text" id="organisationName" v-model="tempFirm.name" />
                </div>
            </div>
        </div>

        <hr />

        <div class="form">
            <div class="grid-x">
                <div class="flexbox-center">
                    <icon class="small-label-svg" name="location" />
                </div>
                <div class="cell small-3 flexbox align-items">
                    <label for="organisationAddress">Adresse</label>
                </div>
                <div class="auto cell">
                    <div id="dawaResults" class="autocomplete-container">
                        <vue-dawa @select="selectAddress($event, 'addressObject')"
                            :val="addressObject.oneLineAddress"
                            :showMax="10"
                            placeholder=""
                            containerId="#dawaResults"
                            :options="{adgangsadresserOnly: true}"
                            fieldId="organisationAddress">
                        </vue-dawa>
                    </div>
                </div>
            </div>
        </div>

        <hr />

        <div class="form">
            <div class="grid-x">
                <div class="flexbox-center">
                    <icon class="small-label-svg" name="phone" />
                </div>
                <div class="cell small-3 flexbox align-items">
                    <label for="organisationPhone">Telefon</label>
                </div>
                <div class="auto cell">
                    <input type="text" id="firm-phone" v-model="tempFirm.phoneNumber" />
                </div>
            </div>
        </div>

        <hr />

        <div class="form">
            <div class="grid-x">
                <div class="flexbox-center" style="width: 40px;"></div>
                <div class="cell small-3"></div>
                <div class="cell auto">
                    <button class="button button-form-primary" :class="{ 'disabled': validateFields() }" @click="save()">{{ buttonnLabel }}</button>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import VueDawa from 'vue-dawa'
import emailValidation from './../../shared/email/email-validation.vue'
import Switches from 'vue-switches'

export default {
    components: {
        'vue-dawa': VueDawa,
        'email-validation': emailValidation,
        Switches
    },
    data () {
        return {
            selectedTab: 1,
            tempFirm: {},
            addressObject: {
                oneLineAddress: ''
            },
            buttonnLabel: 'Gem',
            validEmail: true,
            municipalityCodeFilter: null,
            smsRequest: false,
            spatialFilterOnObjects: false
        }
    },
    computed: {
        ...mapGetters({
            firm: 'getFirm',
            applicationSettingsDrive: 'getApplicationSettingsDrive',
            sysBusinessAreaTypeList: 'getSysBusinessAreaTypeList'
        })
    },
    methods: {
        ...mapActions({
            createUpdateDataOwnerOrganization: 'createUpdateDataOwnerOrganization'
        }),
        translateAddressData (address) {
            if (!address || !address.data) {
                return
            }
            return {
                id: address.data.id,
                street: address.data.vejnavn,
                href: address.data.href,
                streetNumber: address.data.husnr,
                floor: address.data.etage,
                door: address.data.dør,
                zipCode: address.data.postnr,
                city: address.data.postnrnavn,
                secondStreet: address.data.supplerendebynavn,
                oneLineAddress: address.tekst,
                type: address.type
            }
        },
        selectAddress (payload, objectName) {
            this.selectedAddress = true
            this.addressObject = this.translateAddressData(payload)
        },
        validateFields () {
            if (this.tempFirm.name && this.tempFirm.email && this.tempFirm.phoneNumber && this.validEmail) {
                return false
            } else {
                return true
            }
        },
        validEmailResult (result) {
            if (result === null || result) {
                this.validEmail = true
            } else {
                this.validEmail = false
            }
        },
        fieldSettings () {
            var visibleFields = this.applicationSettingsDrive.find(i => i.name === 'show_fields' & i.category === 'ui_setting').value

            if (visibleFields && this.sysBusinessAreaTypeList) {
                visibleFields.forEach(i => {
                    i.displayName = this.sysBusinessAreaTypeList.find(bu => bu.systemName === i.BusinessAreaSystemName).description
                })
                return visibleFields
            }
            return 0
        },
        openModal (view, user) {
            this.$emit('open', view, user)
        },
        save () {
            this.buttonnLabel = 'Gemmer...'
            if (this.addressObject.oneLineAddress !== '') {
                this.firm.address1 = this.addressObject.street + ' ' + this.addressObject.streetNumber
                this.firm.city = this.addressObject.city
                this.firm.postalCode = this.addressObject.zipCode
            }

            new Promise((resolve, reject) => {
                resolve(this.createUpdateDataOwnerOrganization(this.firm))
            }).then(() => {
                this.buttonnLabel = 'Gem'
            })
        }
    },
    watch: {
        firm (val, oldVal) {
            this.tempFirm = val
        }
    },
    created () {
        if (this.firm) {
            this.tempFirm = this.firm
            if (this.firm.address1) {
                this.addressObject.oneLineAddress = this.firm.address1
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/administration/administration-organisation.vue